import { SELECIONAR_VIAGEM } from '../types';

export default function selecionarViagem (viagem) {
  return {
    type: SELECIONAR_VIAGEM,
    payload: viagem
  }
}
